var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuIconEmployeesActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15 15.7166H14.3667C13.7 15.7166 13.0667 15.975 12.6 16.4416L11.175 17.85C10.525 18.4916 9.46668 18.4916 8.81668 17.85L7.39166 16.4416C6.925 15.975 6.28333 15.7166 5.625 15.7166H5C3.61667 15.7166 2.5 14.6083 2.5 13.2417V4.14998C2.5 2.78331 3.61667 1.675 5 1.675H15C16.3833 1.675 17.5 2.78331 17.5 4.14998V13.2417C17.5 14.6 16.3833 15.7166 15 15.7166Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 8.67498C11.0724 8.67498 11.9417 7.80571 11.9417 6.73335C11.9417 5.661 11.0724 4.79167 10 4.79167C8.92765 4.79167 8.05832 5.661 8.05832 6.73335C8.05832 7.80571 8.92765 8.67498 10 8.67498Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2333 12.55C12.9083 12.55 13.3 11.8 12.925 11.2417C12.3583 10.4 11.2583 9.83333 10 9.83333C8.74166 9.83333 7.64166 10.4 7.07499 11.2417C6.69999 11.8 7.09167 12.55 7.76667 12.55H12.2333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIconEmployeesActive);
export default __webpack_public_path__ + "static/media/menu_icon_employees_active.1f47705e47ace8ae600cc15535bed467.svg";
export { ForwardRef as ReactComponent };